export enum BSACTRStatus {
  NEW = 'new',
  APPROVED = 'approved',
  CANCELLED = 'cancelled',
  SUBMITTED = 'submitted',
  ACKNOWLEDGED_WITH_WARNINGS = 'acknowledged_with_warnings',
  ACKNOWLEDGED = 'acknowledged'
}
